import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/MyButton.css";

export default function MyButton({
  type,
  onClick,
  disabled = false,
  danger = false,
  children,
  style = {},
  href = null,
}) {
  // type: default, primary

  const navigate = useNavigate();

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    } else if (href) {
      navigate(href);
    }
  };

  return (
    <div
      className={`mybtn${
        type === "default"
          ? ""
          : type === "primary"
          ? "-primary"
          : type === "link"
          ? "-link"
          : ""
      }${danger ? "-danger" : ""}${disabled ? "-disabled" : ""}`}
      onClick={handleClick}
      style={style}
    >
      {children}
    </div>
  );
}
